import * as React from 'react';
import Common from '../../utilities/common';
import $ from "jquery";
import { Box, Card, CardContent, CircularProgress, Stack, Typography } from '@mui/material';
import FunctionsOutlinedIcon from '@mui/icons-material/FunctionsOutlined';
import ReactInterval from 'react-interval';

export interface IComunidadAutonomaTotalProps {
    title: string;
    field: string;
    icon?: string | JSX.Element | JSX.Element[];
    comunidadAutonoma: string;
    sexField?: boolean;
    showChart?: boolean;
    chartColor?: string;
}

export interface IComunidadAutonomaTotalState {
    total: number;
    current: number;
    totalItems: number;
    showChart: boolean;
}

export default class ComunidadAutonomaTotal extends React.Component<IComunidadAutonomaTotalProps, IComunidadAutonomaTotalState> {
    public constructor(props: IComunidadAutonomaTotalProps) {
        super(props);

        this.state = {
            total: 0,
            current: -1,
            totalItems: 0,
            showChart: this.props.showChart!
        }
    }

    componentWillReceiveProps(nextProps: Readonly<IComunidadAutonomaTotalProps>, nextContext: any): void {
        this.Get(nextProps.comunidadAutonoma);

        if(nextProps.showChart?.valueOf()) {
            this.GetTotal(nextProps.comunidadAutonoma);
        }
    }

    componentDidMount(): void {
        this.Get(this.props.comunidadAutonoma);

        if(this.props.showChart!) {
            this.GetTotal(this.props.comunidadAutonoma);
        }
    }

    public render(): React.ReactElement<{}> {
        return (
            <React.Fragment>
                <ReactInterval timeout={1} enabled={this.state.total > this.state.current} callback={() => {
                    let _current = (this.state.current + 1);
                    
                    this.setState(
                        {
                            current: _current
                        }
                    );
                }}/>
                 <Card>
                    <CardContent>
                        {
                            this.props.icon == null && (
                                <React.Fragment>
                                    <Typography gutterBottom variant="body2" color='text.secondary' component="div">
                                    {
                                        this.props.title
                                    }
                                    </Typography>
                                    {
                                        this.state.current > -1 && (
                                            <Typography variant='h5' color="text.secondary" gutterBottom textAlign='center'>
                                                {
                                                    this.state.current.toLocaleString()
                                                }
                                            </Typography>
                                        )
                                    }
                                </React.Fragment>
                            )
                        }
                        {
                            this.props.icon != null && (
                                <React.Fragment>
                                    <Typography gutterBottom variant="body2" color='text.secondary' component="div">
                                    {
                                        this.props.title
                                    }
                                    </Typography>
                                    <Stack direction='row' spacing={1} justifyContent={'flex-start'}>
                                    {
                                        this.props.icon
                                    }
                                    {
                                        this.state.current > -1 && (
                                            <Typography variant='h5' color="text.secondary" gutterBottom textAlign='center'>
                                                {
                                                    this.state.current.toLocaleString()
                                                }
                                            </Typography>
                                        )
                                    }
                                    {
                                        this.state.showChart && Math.round((this.state.total / this.state.totalItems) * 100) > 0 && (
                                            <Box sx={{ position: 'relative', display: 'inline-flex', top: '7px', marginLeft: 'auto!important' }}>
                                                <CircularProgress variant="determinate" value={(this.state.total / this.state.totalItems) * 100} style={{position: 'relative', top: '-10px'}} sx={{color: !Common.IsNullOrEmpty(this.props.chartColor!) ? this.props.chartColor! : ((this.state.total / this.state.totalItems) * 100) < 75 ? '#f44336' : ((this.state.total / this.state.totalItems) * 100) < 100 ? '#ffc107' : '#4caf50'}}/>
                                                <Box
                                                    sx={{
                                                        top: '-18px',
                                                        left: 0,
                                                        bottom: 0,
                                                        right: 0,
                                                        position: 'absolute',
                                                        display: 'flex',
                                                        alignItems: 'center',
                                                        justifyContent: 'center'
                                                    }}
                                                >
                                                    {
                                                        this.state.totalItems > 0 && (
                                                            <Typography
                                                                variant="caption"
                                                                component="div"
                                                                color="text.secondary"
                                                                style={{fontSize: '10px'}}
                                                            >
                                                                {
                                                                    `${Math.floor((this.state.total / this.state.totalItems) * 100)}%`
                                                                }
                                                            </Typography>
                                                        )
                                                    }
                                                </Box>
                                            </Box>
                                        )
                                    }
                                    </Stack>
                                </React.Fragment>
                            )
                        }
                    </CardContent>
                </Card>
            </React.Fragment>
        )
    }

    private Get(comunidadAutonoma: string) {
        let url = `${Common.END_POINT}/charts/comunidadautonoma/${comunidadAutonoma}/total`;

        if(this.props.sexField?.valueOf()) {
            url += `/sexo/${this.props.field}`
        }
        else if(!Common.IsNullOrEmpty(this.props.field)) {
            url += `/field/${this.props.field}`
        }
        
        $.ajax((
            {
                url: url,
                type: "GET",
                headers: {
                    "Accept": "application/json",
                    "Content-Type": "application/json"
                },
                beforeSend: function (xhr) {
                    xhr.setRequestHeader('Authorization', `Bearer ${Common.GetToken()}`);
                }
            }
        )).done((response: any[]) => {
            if(response.length == 0) {
                this.setState(
                    {
                        total: 0,
                        current: 0
                    }
                );    
            }
            else {
                let current = 0;

                if (response[0].total > 100) {
                    current = response[0].total - Math.round(response[0].total / 10);
                }

                if (response[0].total > 1000) {
                    current = response[0].total - Math.round(response[0].total / 100);
                }

                this.setState(
                    {
                        total: response[0].total,
                        current: current
                    }
                );
            }
        })
    }

    private GetTotal(comunidadAutonoma: string) {
        let url = `${Common.END_POINT}/charts/comunidadautonoma/${comunidadAutonoma}/total`;
        
        $.ajax((
            {
                url: url,
                type: "GET",
                headers: {
                    "Accept": "application/json",
                    "Content-Type": "application/json"
                },
                beforeSend: function (xhr) {
                    xhr.setRequestHeader('Authorization', `Bearer ${Common.GetToken()}`);
                }
            }
        )).done((response: any[]) => {
            if(response.length == 0) {
                this.setState(
                    {
                        totalItems: 0,
                        showChart: true
                    }
                );    
            }
            else {
                console.log(response[0].total);
                this.setState(
                    {
                        totalItems: response[0].total,
                        showChart: true
                    }
                );
            }
        })
    }
}